export var SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/utils/esm/enums.js
// module id = 540
// module chunks = 31 32 35